import { render, staticRenderFns } from "./AppInstallation.vue?vue&type=template&id=b19cb53a&scoped=true"
import script from "./AppInstallation.vue?vue&type=script&lang=ts"
export * from "./AppInstallation.vue?vue&type=script&lang=ts"
import style0 from "./AppInstallation.vue?vue&type=style&index=0&id=b19cb53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19cb53a",
  null
  
)

export default component.exports